<template>
	<a v-if="isExternalLink" :href="to">
		<slot />
	</a>
	<router-link v-else :to="to">
		<slot />
	</router-link>
</template>

<script>
import { isVueRoute, isHybridEnvironment } from "@/common/functions";
export default {
	name: "ZebraLink",
	props: {
		to: {
			type: [String, Object],
			required: true,
		},
		forceExternal: {
			type: Boolean,
			required: false,
			default: null,
		},
	},
	computed: {
		isExternalLink() {
			if (typeof this.forceExternal === "boolean") {
				return this.forceExternal;
			}

			return (
				typeof window === "object" &&
				!isVueRoute(this.toAsHref) &&
				isHybridEnvironment(window.location.origin)
			);
		},
		toAsHref() {
			if (typeof this.to === "string") {
				return this.to;
			}

			return this.$router.resolve(this.to).href;
		},
	},
};
</script>
